import { gql } from '@apollo/client';

export const CONFIRM_TOOL_BOOKING = gql`
  mutation ConfirmToolBooking($id: ID!, $message: String) {
    confirmToolBooking(input: { id: $id, message: $message }) {
      toolBooking {
        id
        status
        fromDate
        toDate
      }
      errors
    }
  }
`;
